document.addEventListener('DOMContentLoaded', function() {
  const mobileToggle = document.querySelector('.hims-header__mobile-toggle');
  const mobileMenu = document.querySelector('.hims-header__mobile-menu');
  
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileToggle.classList.toggle('active');
      mobileMenu.classList.toggle('active');
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.hims-header__mobile-toggle') && 
          !event.target.closest('.hims-header__mobile-menu')) {
        mobileToggle.classList.remove('active');
        mobileMenu.classList.remove('active');
      }
    });
  }
});
